import React from "react";
import HeroSection from "./components/Hero2";
import Services from "./components/Services";
import Projets from "./components/Projets";
import Contact from "./components/Contact";
import Testimonials from "./components/Testimonials";
import Team from "./components/NotreEquipe";

const Homepage = () => {
  return (
    <div>
      <HeroSection />
      <Services />
      <Projets />
      <Testimonials />
      <Team />
      <Contact />
    </div>
  );
};

export default Homepage;
